import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Space from '@src/components/Space';
import NotFound from '@src/components/NotFound';

import css from './style.module.scss';

const CardsGrid = (props) => {
	const {
		items,
		notFoundProps,
		onClickMap,
		onClickLike,
		adaptive,
		onResetClick,
		adv,
	} = props;

	const itemsNodes = items.map((item) => {
		return (
			<div className={cn(css.item)} key={item.id}>
				<Space
					{...item}
					preview={null}
					state="large"
					onClickMap={onClickMap}
					onClickHeart={onClickLike}
				/>
			</div>
		);
	});

	if (adv) {
		itemsNodes.push(
			<div className={cn(css.item)} key="adv">
				{adv}
			</div>,
		);
	}

	return (
		<div
			className={cn(css.block, {
				[css[`block_adapt_${adaptive}`]]: !!adaptive,
			})}
		>
			{items.length === 0 && (
				<div className={css.notFound}>
					<NotFound onClickReset={onResetClick} {...notFoundProps} />
				</div>
			)}
			<div className={css.grid}>{itemsNodes}</div>
		</div>
	);
};

CardsGrid.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape(Space.type.propTypes)),
	notFoundProps: PropTypes.shape(NotFound.type.propTypes),
	onClickMap: PropTypes.func,
	onClickLike: PropTypes.func,
	onResetClick: PropTypes.func,
	adaptive: PropTypes.oneOf([null, 'spaces']),
	adv: PropTypes.element,
};

CardsGrid.defaultProps = {
	items: [],
	onClickMap: undefined,
	onClickLike: undefined,
	notFoundProps: undefined,
	adaptive: null,
	onResetClick: undefined,
	adv: undefined,
};

export default CardsGrid;
